import React, { Component } from 'react'
import { array_chunk } from '../../helper'

import Card from './Card'

export class index extends Component {
    listContents() {
        let { contents } = this.props

        let chunks = []
        array_chunk(contents, 6, (contentsChunk) => {
            chunks.push(contentsChunk)
        })

        return (
            chunks.map(chunk => {
                return (
                    chunk.map((content, index) => {
                        let colLg;
                        if (index < 3) {
                            colLg = 4;
                        }

                        if (index >= 3 && index < 5) {
                            colLg = 6;
                        }

                        if (index === 5) {
                            colLg = 12;
                        }

                        return <Card {...content} key={content.id} classes={`col-span-12 md:col-span-6 lg:col-span-${colLg}`} />
                    })
                )
            })
        );
    }

    render() {
        let { contents } = this.props;
        return (
            <>
                {contents.length !== 0 && this.listContents()}

                {/*
                <Card classes="lg:col-span-4" />
                <Card classes="lg:col-span-6" />
                <Card classes="lg:col-span-12" /> */}
            </>
        )
    }
}

export default index